import { DatePicker } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";

export default function NDSDatePicker({ field: name, onChange, ...ndsProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = (value) => {
    if (onChange) {
      onChange({ setFieldValue, value });
    }
    helpers.setValue(value);
  };

  return (
    <DatePicker
      dateFormat="MMMM d, yyyy"
      errorMessage={meta.error}
      onChange={handleChange}
      selected={field.value}
      {...ndsProps}
    />
  );
}
